import { Component, Injectable, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { ILinkUp } from '@pdqdev/pdq-shared/dist/interfaces/ILinkUp';
import { SettingsService } from '@services/settings/settings.service';
import * as fromLinkUpReducer from '@settings/link-up/store/reducers/link-up.reducers';
import { LinkUpActions } from '../../store/actions';

@Injectable()
@Component({
  selector: 'link-up-workstation-devices',
  templateUrl: './link-up-workstation-devices.component.html',
  styleUrls: ['./link-up-workstation-devices.component.scss'],
  standalone: false,
})
export class LinkUpWorkstationDevicesComponent implements OnInit {
  @Input() devices: ILinkUp.Device[];
  @Input() shareable: boolean = false;
  constructor(
    private settingsService: SettingsService,
    private store: Store<fromLinkUpReducer.State>,
  ) {}

  ngOnInit(): void {}

  onShareDevice(device: ILinkUp.Device, value: boolean) {
    this.store.dispatch(LinkUpActions.editLinkUpDevice({ params: { share: value }, deviceId: device.id }));
  }
}
